import { Content } from "components/Layout";
import React from "react";
import Piepagina from "../Layout/FooterHomePublica";

const EmptyLayout = ({ children, ...restProps }) => (
  <main className="" {...restProps}>
    <Content fluid >
      {children}
    </Content>
  </main>
  
);

export default EmptyLayout;
